import ApiGServer from "services/ApiGServer";

const updateEquipmentFields = async (serials, filds) => {
  try {
    const response = await ApiGServer.put("/equipment/update-equipments-fields", { serials, filds });
    return response.data;
  } catch (error) {
    console.error("Error updating equipments:", error);
    throw error;
  }
};

export { updateEquipmentFields };
